/** Service Desk console: ang catalogue (mga produkto, sync, live price test, visibility) (SD-S2-21, WP-S2-H). */
export const serviceCatalogue = {
  title: "Katalogo",
  subtitle: "Mga produkto, SKU, stock at presyong naka-cache mula sa order system mo. Ang system mo pa rin ang pinagmumulan ng katotohanan; hindi kailanman nag-iimbento ng presyo ang Sagot.",
  profileLink: "Commerce profile",
  error: { title: "Hindi ma-load ang katalogo", body: "Hindi apektado ang order system mo. Subukan ulit." },
  banner: {
    paused: "Naka-pause ang pag-order. Naka-cache na item ang ipinapakita; hindi makakapag-order ang mga kliyente hangga't hindi mo ito ibinabalik.",
    unhealthy: "Hindi maayos ang connector. Naka-cache na item ang gamit sa pag-browse; hindi available ang live na presyo at stock check.",
    settings: "Commerce profile",
  },
  tabs: { label: "Mga seksyon ng katalogo", products: "Mga Produkto", visibility: "Visibility" },
  stats: {
    label: "Kabuuan ng katalogo",
    active: "Aktibong item",
    activeHint: "na mahahanap ng mga kliyente",
    categories: "Mga kategorya",
    categoriesHint: "sa katalogo",
    low: "Kaunti ang stock",
    lowHint: "nasa o mas mababa sa low-stock level",
    made: "Gawa kapag inorder",
    madeHint: "lead time sa halip na stock",
  },
  stock: { unknown: "Hindi alam ang stock", in_stock: "May stock", low: "Kaunti na ang stock", out: "Ubos na", made_to_order: "Gawa kapag inorder" },
  sync: {
    title: "Naka-sync mula sa {{name}}",
    csvTitle: "Katalogo mula sa CSV file",
    system: "order system mo",
    healthy: "Maayos",
    unhealthy: "Hindi maayos",
    paused: "Naka-pause",
    noProfile: "Walang commerce profile",
    last: "Huling sync",
    lastValue: "{{when}} · {{items}} item ang nabasa · {{changed}} ang nagbago",
    never: "Hindi pa nasi-sync",
    running: "Nagsi-sync ngayon…",
    next: "Susunod na sync",
    nextValue: "Gabi-gabi ng {{at}}, kada {{minutes}} minuto ang mga pagbabago, kada {{poll}} minuto ang status ng mga order.",
    lastFailed: "Nabigo ang huling sync. Mula sa sync bago nito ang mga naka-cache na item sa ibaba.",
    historyFailed: "Hindi ma-load ang kasaysayan ng sync.",
    now: "I-sync ngayon",
    started: "Nagsimula ang sync.",
    joined: "May tumatakbo nang sync. Makikita mo ang resulta dito.",
    history: "Kasaysayan ng sync",
    csvInstead: "Mag-upload ng CSV sa halip",
    uploadCsv: "Mag-upload ng CSV ng mga produkto",
  },
  filters: {
    search: "Hanapin ang SKU, produkto, kategorya o modelo",
    searchLabel: "Maghanap sa katalogo",
    category: "Kategorya",
    allCategories: "Lahat ng kategorya",
    stockGroup: "Filter ng stock",
    allStock: "Lahat ng stock",
    activeOnly: "Aktibo lang",
    clear: "I-clear ang mga filter",
  },
  list: {
    label: "Katalogo",
    product: "Produkto",
    category: "Kategorya",
    unit: "Yunit",
    price: "List price",
    stock: "Stock",
    lead: "Lead time",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
    hidden: "Nakatago sa pag-order",
    open: "Buksan ang {{name}}",
    showing: "Ipinapakita ang {{shown}} sa {{total}} item",
  },
  empty: {
    title: "Wala pang produkto",
    body: "Ikonekta ang order system mo para ma-sync ang katalogo gabi-gabi, o mag-upload ng CSV kung wala kang API.",
    setup: "I-set up ang commerce profile",
    filteredTitle: "Walang tugmang produkto",
    filteredBody: "Subukan ang ibang hanap o i-clear ang mga filter. Hinahanap din ang mga modelo.",
  },
  drawer: {
    loading: "Produkto",
    notFoundTitle: "Hindi mahanap ang produktong ito",
    notFoundBody: "Maaaring na-archive na ito. Bumalik sa listahan.",
    archived: "Naka-archive",
    notOrderable: "Nakatago sa pag-order",
    cached: "Naka-cache na datos",
    sku: "SKU",
    category: "Kategorya",
    unit: "Yunit",
    listPrice: "List price",
    vatIn: "(kasama ang VAT)",
    vatEx: "(hindi kasama ang VAT)",
    stock: "Stock",
    lead: "Lead time",
    minQty: "Minimum na order / hakbang",
    synced: "Huling na-sync",
    source: { sync: "Mula sa order system mo", csv: "Mula sa CSV", manual: "Idinagdag nang mano-mano" },
    compatible: "Tugma sa",
    availability: "Availability",
    orderable: "Pwedeng i-order sa chat",
    orderableHint: "Itago ang produkto sa pag-order nang hindi inaalis sa system mo.",
    orderableOn: "Pwede nang i-order ulit.",
    orderableOff: "Nakatago na sa pag-order.",
    visible: "Nakikita ng mga kliyente",
    visibleHint: "I-off para hindi ito lumabas sa paghahanap at product card.",
    visibleOn: "Nakikita na ulit ng mga kliyente.",
    visibleOff: "Nakatago na sa mga kliyente.",
    raw: "Mga na-map na field",
  },
  live: {
    title: "Subukan ang live na presyo",
    customer: "Customer code",
    customerHint: "Ang customer code na kilala ng system mo sa organisasyon.",
    qty: "Dami",
    run: "Subukan ang live na presyo",
    limit: "Isang beses tatawagin ang price operation. Hanggang 10 pagsubok kada minuto.",
    ok: "{{status}} OK",
    failed: "Nabigo ang tawag",
    duration: "{{ms}} ms",
    canonical: "Canonical na resulta",
    noMapping: "Gumana ang tawag, pero walang field na ibinalik ang mapping. Suriin ang mapping ng price operation.",
    problem: { customer: "Maglagay ng customer code.", qty: "Maglagay ng buong dami mula 1 hanggang {{max}}." },
    unavailable: {
      noAccess: "Kailangan mo ng pahintulot na subukan ang mga connector operation para makapagsubok ng live na presyo.",
      noConnector: "Wala pang connector na naka-set up para sa commerce profile.",
      noBinding: "Mag-bind ng get_price operation sa commerce profile para masubukan ang live na presyo.",
    },
  },
  history: {
    title: "Kasaysayan ng sync",
    description: "Mga sync na gabi-gabi at mano-mano, pinakabago muna.",
    label: "Mga sync ng katalogo",
    when: "Kailan",
    mode: "Paraan",
    items: "Mga item",
    changes: "Mga pagbabago",
    result: "Resulta",
    kind: { full: "Buo", incremental: "Mga pagbabago lang", csv: "CSV" },
    origin: { schedule: "naka-iskedyul", manual: "mano-mano" },
    status: { queued: "Nakapila", running: "Tumatakbo", succeeded: "Matagumpay", partial: "Bahagyang nabigo", failed: "Nabigo" },
    truncated: "Huminto sa limit ng pahina: hindi nabasa ang bahagi ng katalogo.",
    emptyTitle: "Wala pang sync",
    emptyBody: "Tatakbo ang unang sync kapag handa na ang commerce profile, o pindutin ang I-sync ngayon.",
  },
  visibility: {
    title: "Visibility ng katalogo",
    intro: "Piliin kung ano ang nakikita ng bawat organisasyon ng kliyente. Kapag walang rule, nakikita ng organisasyon ang buong katalogo.",
    organisation: "Organisasyon",
    rule: "Nakikita",
    action: "Aksyon",
    edit: "I-edit",
    editFor: "I-edit kung ano ang nakikita ng {{name}}",
    summaryAll: "Lahat",
    summaryCategories_one: "{{count}} kategorya",
    summaryCategories_other: "{{count}} kategorya",
    summarySkus_one: "{{count}} produkto",
    summarySkus_other: "{{count}} produkto",
    emptyTitle: "Wala pang organisasyon",
    emptyBody: "Magdagdag muna ng mga organisasyon ng kliyente; saka piliin kung ano ang nakikita ng bawat isa.",
    dialogTitle: "Ano ang nakikita ng {{name}}",
    dialogBody: "Ang rule ay umiiral sa paghahanap, product card at pag-order ng organisasyong ito.",
    mode: "Visibility",
    modes: { all: "Lahat", categories: "Ilang kategorya", allow_list: "Mga nakalistang produkto lang" },
    modeHints: { all: "Ang buong aktibong katalogo.", categories: "Mga produkto sa mga kategoryang ita-tick mo.", allow_list: "Ang mga SKU lang na ililista mo." },
    categories: "Mga kategorya",
    noCategories: "Wala pang kategorya ang katalogo.",
    skus: "Mga SKU na papayagan",
    skusHint: "I-paste ang mga SKU na pinaghihiwalay ng kuwit, espasyo o bagong linya.",
    addSkus: "Idagdag ang mga SKU",
    skuList: "Mga pinapayagang SKU",
    removeSku: "Alisin ang {{sku}}",
    problem: { categories: "Mag-tick ng kahit isang kategorya.", skus: "Maglista ng kahit isang SKU.", tooMany: "Mas marami ito sa kayang hawakan ng rule." },
    save: "I-save ang rule",
    saved: "Na-save ang rule ng {{name}}.",
    reset: "Ibalik sa lahat",
    cleared: "Nakikita na ulit ng {{name}} ang lahat.",
  },
} as const;
